import css from 'styled-jsx/css';

export default css`
  :global(.button-group-container) {
    display: flex;
    flex-direction: row;
    background-color: var(--card-border);
    border-radius: 8px;
    padding: 2px;
    height: 60px;
    align-items: center;
    cursor: pointer;
  }

  :global(.button-group-item) {
    width: 110px;
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    transition: 0.4s;
  }

  :global(.selected-button-group-item) {
    background-color: var(--white);
    border-radius: 8px;
    cursor: default;
  }

  :global(.button-group-label) {
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 35px;
    letter-spacing: 0.00636364em;
    color: #637483;
  }

  :global(.selected-button-group-label) {
    cursor: default;
    font-style: normal;
    font-weight: 900;
    font-size: 15px;
    line-height: 35px;
    letter-spacing: 0.00636364em;
    color: var(--grey-dark);
  }

  @media screen and (max-width: 425px) {
    :global(.button-group-container) {
      display: flex;
      flex-direction: row;
      background-color: var(--card-border);
      border-radius: 8px;
      padding: 2px;
      height: 40px;
      align-items: center;
      cursor: pointer;
    }
  }
`;
